module.exports = __webpack_public_path__ + "media/images/cleaning/cover-mobile@3x-da44e430ed1e75fa8bd52caf7a1da264.jpg";